import VBtn from './VBtn';

VBtn.install = function install(Vue) {
  Vue.component(VBtn.name, VBtn);
};

export default VBtn;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VBtn/index.js
// module id = 7Q1V
// module chunks = 0